import { padEnd } from 'lodash';

export const formatCurrency = (amount: number, unit: string = 'USD') =>
  `$${padEnd(amount.toFixed(2).toString(), 4, '0')} ${unit}`;
